import React from "react";
import { Link } from "react-router-dom";

const ResetPasswordLinkExpired = () => {
  return (
    <div className="change-password-confirm">
      <div className="background-wrapper creamy-cement" />
      <h2>
        Your reset password link is expired. Please click&nbsp;
        <Link to="/reset-password">here</Link> to get a new one.
      </h2>
    </div>
  );
};

export default ResetPasswordLinkExpired;
